// extracted by mini-css-extract-plugin
export var infoRow = "_sn-2";
export var labelContainer = "_sn-0";
export var rightInfo = "_sn-1";